import { cacheStep, } from "./types";
import { JsCustomBehavior } from "./JsCustomBehavior";
export class JsCustomBehaviors {
    constructor(behaviors, properties, datasets) {
        this.agentCache = {
            [cacheStep]: 0,
        };
        this.behaviors = behaviors.map((b) => new JsCustomBehavior(b, properties, datasets, this.agentCache));
    }
    updateAgentCache(agents) {
        const currentStep = this.agentCache[cacheStep] + 1;
        this.agentCache[cacheStep] = currentStep;
        const agentsToRemove = [];
        let stop = null;
        for (const agent of agents) {
            for (const msg of agent.messages || []) {
                if (msg.type === "create_agent" &&
                    ((Array.isArray(msg.to) &&
                        msg.to.map((to) => to.toLowerCase()).includes("hash")) ||
                        (typeof msg.to === "string" &&
                            msg.to.toLowerCase().includes("hash")))) {
                    const cached = msg.data;
                    cached[cacheStep] = currentStep;
                    this.agentCache[msg.data.agent_id] = msg.data;
                }
                if (msg.type === "remove_agent" &&
                    ((Array.isArray(msg.to) &&
                        msg.to.map((to) => to.toLowerCase()).includes("hash")) ||
                        (typeof msg.to === "string" &&
                            msg.to.toLowerCase().includes("hash")))) {
                    agentsToRemove.push(msg.data.agent_id);
                }
                if (msg.type === "stop" && is_hash_msg(msg.to) && !stop) {
                    stop = { data: msg.data };
                }
            }
            const cached = agent;
            cached[cacheStep] = currentStep;
            this.agentCache[agent.agent_id] = cached;
        }
        for (const killedId of agentsToRemove) {
            delete this.agentCache[killedId];
        }
        return stop;
    }
    updateProperties(props) {
        this.behaviors.forEach((b) => b.updateProperties(props));
    }
    len() {
        return this.behaviors.length;
    }
    behavior(i) {
        return this.behaviors[i];
    }
}
const is_hash_msg = (to) => {
    if (Array.isArray(to)) {
        return to.map((to) => to.toLowerCase()).includes("hash");
    }
    return to.toLowerCase() === "hash";
};
//# sourceMappingURL=JsCustomBehaviors.js.map